import script from "./work-force-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./work-force-details.vue?vue&type=script&setup=true&lang=ts"

import "./work-force-details.vue?vue&type=style&index=0&id=b5d599fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d599fe"]])

export default __exports__